import React, { useEffect, useState } from "react";
import { Button, LinearProgress, MenuItem, Paper, Select, TextField, Typography } from "@material-ui/core";
import _ from 'lodash'
import { motion } from "framer-motion";

const fields_names = [
  { id: 'TI', name: 'Title' },
  { id: 'ABS', name: 'Abstract' },
  { id: 'CSP', name: 'Complete Specification' },
  { id: 'AP', name: 'Application Number' },
  { id: 'patent-number', name: 'Patent Number' },
  { id: 'PA', name: 'Applicant Name' },
  { id: 'ANC', name: 'Applicant Country' },
  { id: 'ANA', name: 'Applicant Address' },
  { id: 'IN', name: 'Inventor Name' },
  { id: 'INC', name: 'Inventor Country' },
  { id: 'INA', name: 'Inventor Address' },
  { id: 'FO', name: 'Filing Office' },
  { id: 'IC', name: 'International Patent Classification (IPC)' },
  { id: 'PAP', name: 'PCT Application Number' },
]
const PatentSearchHeader = ({ handleSearch, progress }) => {

  const [queryString, setQueryString] = useState('')
  const [searchBoxes, setSearchBoxes] = useState([
    { field: 'TI', searchText: '', logic: 'AND' },
  ])

  const addSearchField = () => {
    if (searchBoxes.length >= 10) return;
    setSearchBoxes(searchBoxes.concat({ field: fields_names[searchBoxes.length].id, searchText: '', logic: 'AND' }))
  }
  const removeSearchField = () => {
    setSearchBoxes(searchBoxes.splice(0, searchBoxes.length - 1))
  }

  const setSearchText = (t_index, value) => {
    const updated_arr = searchBoxes.map((item, index) => {
      if (index === t_index) return { ...item, searchText: value }; else return item;
    })
    setSearchBoxes(updated_arr)
  }

  const setField = (t_index, value) => {
    const updated_arr = searchBoxes.map((item, index) => {
      if (index === t_index) return { ...item, field: value }; else return item;
    })
    setSearchBoxes(updated_arr)
  }

  const setLogic = (t_index, value) => {
    const updated_arr = searchBoxes.map((item, index) => {
      if (index === t_index) return { ...item, logic: value }; else return item;
    })
    setSearchBoxes(updated_arr)
  }


  useEffect(
    () => {
      let tempSearchBoxes = []
      _.forEach(searchBoxes, (item, index) => {
        const searchTexts = item.searchText.trim().split(' ')
        _.forEach(searchTexts, (itemx, index) => {
          tempSearchBoxes = tempSearchBoxes.concat({ ...item, searchText: searchTexts[index] })
        })
      })
      let qs = ""
      _.forEach(tempSearchBoxes, (item, index) => {
        let num = index + 1
        qs = qs + "ItemField" + num + "=" + item.field + "&TextField" + num + "=" + item.searchText + "&LogicField" + num + "=" + item.logic + "&"
      })
      setQueryString(qs)
    }, [searchBoxes]
  )

  return (
    <motion.div
      initial={{ y: -20 }}
      animate={{ y: 0, transition: { delay: .2 } }}
      className="relative w-full bg-white shadow p-4 flex flex-col pb-4">
      <h1 className="text-3xl">Patent Search</h1>
      <Typography color={"textSecondary"} className="text-3xl pb-4">Search by Title or by making
        combinations</Typography>
      {/*<p className="text-gray-500">//</p>*/}
      {searchBoxes.map((searchBox, index) => (
        <motion.div
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}


          className="flex flex-row mt-2 mb-1 space-x-4">
          <TextField
            size='small'
            select
            value={searchBox.field}
            style={{ width: 140 }}
            variant={"outlined"}
            className="mr-1"
            onChange={(e) => setField(index, e.target.value)}>
            {fields_names.map(field => (
              <MenuItem value={field.id}>{field.name}</MenuItem>
            )
            )}
          </TextField>
          <TextField
            size='small'
            variant='outlined'
            style={{ width: 100 }}

            label=""
            className='w-full ml-1 rounded-none flex-1 text-lg'
            placeholder={'Search by ' + _.find(fields_names, { id: searchBox.field }).name}
            InputLabelProps={{
              shrink: true,
            }}
            value={searchBox.searchText}
            onChange={(e) => setSearchText(index, e.target.value)}
            onKeyDown={e => e.keyCode === 13 && handleSearch(queryString)}
          />
          {searchBoxes.length === (index + 1) ?
            <Button variant={"contained"}
              color={"primary"}
              size='small'
              className="px-4"
              onClick={() => handleSearch(queryString)}
              style={{ width: 50 }}>Search</Button>
            :
            <TextField
              select
              size='small'
              value={searchBox.logic}
              style={{ width: 100 }}
              variant={"outlined"}
              onChange={(e) => setLogic(index, e.target.value)}>
              <MenuItem value='AND'>AND</MenuItem>
              <MenuItem value='OR'>OR</MenuItem>
            </TextField>

          }
        </motion.div>
      ))}
      <div className='flex flex-row space-x-4'>
        {searchBoxes.length < 10 &&
          <Typography onClick={addSearchField} color='primary' className='self-start pt-4 cursor-pointer'>+
            Add field</Typography>}
        {searchBoxes.length > 1 &&
          <Typography onClick={removeSearchField}
            color='primary'
            className='self-start pt-4 cursor-pointer'>- Remove last
            field</Typography>}

      </div>
      {/*<Typography>{queryString}</Typography>*/}
      <LinearProgress hidden={!progress} className='mt-4 -mx-4 -mb-4' />
    </motion.div>
  )
}

export default PatentSearchHeader;